export default __webpack_public_path__ + "static/quote-card-3-f24ff9d5cbd9fbb4f9dee59ec4f88317323608e0d97399ce2c059f3855dc175d.png";